import { Component } from '@angular/core';
import { HvtSection1Dto, HvtSection1ContactDto } from '../../../models/notices/ojeu.notice.models';
import { OjeuEnumsToSelectList, FormType, CaType, CaActivity, CeActivity } from '../../../models/notices/ojeu.notice.enums';
import { SelectableItem } from '../../../models/common/selectableItem';
import { HvtSectionBase } from './hvt.section.base';

@Component({
    selector: 'hvt-s1',
    template: require('./hvt.section.1.component.html')
})
export class HvtS1Component extends HvtSectionBase<HvtSection1Dto> {
    hvtS1: HvtSection1Dto;
    primaryAddress: HvtSection1ContactDto;
    additionalAddresses: Array<HvtSection1ContactDto>;
    caTypes: Array<SelectableItem<CaType>>;
    caActivities: Array<SelectableItem<CaActivity>>;
    ceActivities: Array<SelectableItem<CeActivity>>;

    furtherInfoAddress: HvtSection1ContactDto;
    participationAddress: HvtSection1ContactDto;

    isF24: boolean;

    constructor() {
        super();
        this.caTypes = OjeuEnumsToSelectList.getCaTypeList();
        this.caActivities = OjeuEnumsToSelectList.getCaActivityList();
        this.ceActivities = OjeuEnumsToSelectList.getCeActivityList();
    }

    populate(hvtS1: HvtSection1Dto, formType: FormType) {
        this.hvtS1 = hvtS1;
        this.formType = formType;
        this.isF24 = this.formType === FormType.F242014;

        this.primaryAddress = this.hvtS1.contacts.find((c: HvtSection1ContactDto) => {
            return c.isPrimaryContact;
        });

        this.furtherInfoAddress = this.hvtS1.contacts.find((c: HvtSection1ContactDto) => {
            return c.isFurtherInfoContact;
        });

        this.participationAddress = this.hvtS1.contacts.find((c: HvtSection1ContactDto) => {
            return c.isParticipationContact;
        });

        this.additionalAddresses = this.hvtS1.contacts.filter((c: HvtSection1ContactDto) => {
            return c !== this.primaryAddress && c !== this.furtherInfoAddress && c !== this.participationAddress;
        });


    }

    clear() {
        this.hvtS1 = null;
        this.formType = null;
        this.primaryAddress = null;
        this.furtherInfoAddress = null;
        this.participationAddress = null;
        this.additionalAddresses = null;
    }

    getCaTypeText() {
        if (this.hvtS1.caType !== CaType.Other) {
            return this.caTypes.find(ca => {
                return ca.value === this.hvtS1.caType;
            }).text;
        }

        return `Other type: ${this.hvtS1.caTypeOther}`;
    }

    getCaActivityText() {
        if (this.hvtS1.caActivity !== CaActivity.Other) {
            return this.caActivities.find(ca => {
                return ca.value === this.hvtS1.caActivity;
            }).text;
        }

        return `Other activity: ${this.hvtS1.caActivityOther}`;
    }

    getCeActivityText() {
        if (this.hvtS1.ceActivity !== CeActivity.Other) {
            return this.ceActivities.find(ce => {
                return ce.value === this.hvtS1.ceActivity;
            }).text;
        }

        return `Other activity: ${this.hvtS1.ceActivityOther}`;
    }

    showSectionI2() {
        return this.formType !== FormType.F152014 && !this.isF24;
    }

    showSectionI3() {
        return this.formType !== FormType.F032014 && this.formType !== FormType.F152014 && this.formType !== FormType.F062014;
    }

    showSectionI4() {
        return this.formType !== FormType.F042014 && this.formType !== FormType.F052014 && this.hvtS1.caType !== CaType.None;
    }

    showSectionI5() {
        return this.formType !== FormType.F042014 && this.formType !== FormType.F052014 && this.hvtS1.caActivity !== CaActivity.None;
    }

    showSectionI6() {
        return (this.formType === FormType.F042014 ||
                this.formType === FormType.F052014 ||
                this.formType === FormType.F062014 ||
                this.formType === FormType.F152014) &&
            this.hvtS1.ceActivity !== CeActivity.None;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.1.component.ts